import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';
import { svgIconClassName } from '@domonda/ui';

const styles = createStyles(({ typography, palette, spacing }) => ({
  root: {
    padding: spacing(1, 0),
  },
  item: {
    '&:not(:last-child)': {
      marginBottom: spacing(1),
    },
  },
  itemAdd: {
    marginLeft: '6px',
    padding: 0,
  },
  details: {
    padding: spacing(1),
    border: `1px solid ${palette.border}`,
    borderRadius: '5px',
  },
  additionalDetails: {
    maxHeight: '35vh',
    display: 'flex',
    backgroundColor:'white',
    zIndex: 11,
    position: 'absolute',
    bottom: 0,
    right: 0,
    boxShadow: '1px -2px 4px rgba(0, 0, 0, 0.2)',
    transition: '0.4s ease all',
  },
  containerIdWrapper: {
    padding: "14px 20px 0 50px",
    marginRight: '20px',
    borderRight:'1px solid #CFDDE2',
    width: '500px',
  },
  itemWrapper: {
    padding: "14px 10px 0 10px",
    width: '275px'
  },
  containerIdTitle: {
    margin: 0,
    fontSize: '12px',
    textTransform: 'uppercase',
    fontWeight: 700,
    color: '#4A4A4A',
    marginBottom: '5px',
  },
  containerIdText: {
    marginTop: 0,
    marginBottom: '2px',
    fontSize: '14px',
    color: '#4A4A4A',

  },
  detailsToggler: {
    display: 'none',

    '&:checked': {
      '& ~ $detailsSummary': {
        paddingBottom: spacing(1),

        [`& .${svgIconClassName}`]: {
          transform: 'rotate(-180deg)',
        },
      },

      '& ~ $detailsContent': {
        display: 'block',
      },
    },
  },
  detailsSummary: {
    width: '100%',
    paddingBottom: 0,
    fontWeight: typography.weights.semiBold,
    color: palette.light('textPrimary'),
    textTransform: 'uppercase',
    cursor: 'pointer',
    fontSize: '12px',
    // XXX-jht-190402 chrome does not suppport list-style: none
    '&::-webkit-details-marker': {
      display: 'none',
    },
    '&:hover': {
      color: palette.textPrimary,
    },
    '&:focus, &:active': {
      outline: 'none',
    },
    [`& .${svgIconClassName}`]: {
      transition: 'transform 100ms',
      marginLeft: spacing(1),
      marginBottom: -4,
    },
  },
  detailsContent: {
    display: 'none',
  },
  arrowIcon: {
    position: 'absolute',
    top: '-12px',
    right: '30px',
    overflowY: 'scroll',
    overflowX: 'hidden',
    zIndex: 30,
    transition: '0.4s ease all',
  },
  innerContainer: {
    display: 'flex',
    position: 'relative',
    width: '100%',
  },
  hideProperties : {
    maxHeight: '55px',
  },
  rotateIcon : {
    transform:'rotate(180deg)',
  },
  lineItemCell : {
    padding: '8px',
    border: '1px solid #cfdde2',
  },
  lineItemHeading : {
    textAlign: 'right',
    padding: '8px',
    border: '1px solid #cfdde2',
  },
}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
